<template>
  <div v-if="running_order">
    <v-card-text style="height: 532px; overflow-y: auto;">
      <v-layout row wrap>
        <v-flex xs6 pr-1>
          <v-text-field v-model="running_order.name" label="Name"></v-text-field>
        	Items:

        	<v-layout row wrap v-for="(item, idx) in running_order.items" style="" :key="idx">
        		<v-flex xs2>
        			<v-select hide-details placeholder=" " label="Action" :items="actions" v-model="item.action"></v-select>
	        	</v-flex>
	        	<v-flex xs2>
	        		<v-select hide-details placeholder=" " label="Type" :items="types(item)" v-model="item.type"></v-select>
	        	</v-flex>
	        	<v-flex xs2>
	        		<v-text-field placeholder=" " v-if="is_duration(item)" hide-details v-model="item.duration" label="Duration (ms)"></v-text-field>
	        	</v-flex>
	        	<v-flex xs5>
	        		<v-select placeholder=" " hide-details label="Input" :items="inputs" v-model="item.input" v-if="item.action == 'mixer'"></v-select>
	        		<v-text-field placeholder=" " hide-details v-model="item.uri" label="Uri" v-if="item.action == 'player' && item.type == 'play'"></v-text-field>
	        	</v-flex>
	        	<v-flex xs1>
	        		<v-btn small flat color="green" @click="add_after(idx)" style="min-width: 10px; margin-left: 0px; margin-right: 0px;">+</v-btn>
	        		<v-btn small flat color="red" @click="remove_at(idx)" style="min-width: 10px; margin-left: 0px; margin-right: 0px;">-</v-btn>
	        	</v-flex>

        	</v-layout>
        	<v-btn small color="success" @click="add_after(-1)">Add up</v-btn>
        	<v-btn small color="success" @click="add_item">Add</v-btn>

        </v-flex>


        <v-flex xs6 pl-1>
          Fields:
          <json-editor v-model="running_order.items" v-if="running_order.items"></json-editor>
        </v-flex>
      </v-layout>

    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="reset">Reset</v-btn>
      <v-btn color="success" @click="save(false)">Save</v-btn>
      <v-btn color="success" @click="save(true)">Save and close</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import JsonEditor from '@/components/JsonEditor'
export default {
  props: ['id'],
  components: {
    JsonEditor
  },
  data() {
    var ch = this.$cloudserver.channel((typeof(this.id) == "undefined" ? "running_orders:create" : "running_orders:" + this.id));
    return {
      ws_channel: ch,
      running_order: this.convert(ch.data),
      actions: ["mixer", "wait", "player"],
      inputs: ["loop", "black", "live", "player"],
    };
  },
  watch: {
    'ws_channel.data': {
      handler(val) {
        this.running_order = this.convert(val)
      },
      deep: true
    }
  },
  computed: {
  },
  created() {
    this.ws_channel.join();
  },
  methods: {
  	is_duration (item) {
  		if (item.action == "mixer") {
  			if (item.type == "fade") return true;
  		}
  		if (item.action == "wait") {
  			if (item.type == "duration") return true;
  		}
  		if (item.action == "player") {
  			if (item.type == "play") return true;
  		}
  		return false;
  	},
  	add_after(idx) {
  		this.running_order.items.splice(idx + 1, 0, {})
  	},
  	remove_at(idx) {
  		this.running_order.items.splice(idx, 1);
  	},
  	add_item () {
  		this.running_order.items.push({})
  	},
  	types (item) {
  		if (item.action == "player") return ["play"];
  		if (item.action == "mixer") return ["fade", "cut"];
  		if (item.action == "wait") return ["duration", "action", "end"];
  	},
    convert (val) {
      return _.cloneDeep(val);
    },
    reset() {
      console.log(this.ws_channel);
      this.list_type = this.convert(this.ws_channel.data);
    },
    save (close) {
      var self = this;
      if (typeof(this.ws_channel) != "undefined") {
      	var send_ro = _.cloneDeep(this.running_order);
      	console.log("Saving RO", send_ro);
      	this.ws_channel.push("save", {running_order: send_ro})
      	.receive("ok", (msg) => {
      		if (typeof(self.id) == "undefined") {
          	self.$message.success("Running order was created!");
          } else {
      			self.$message.success("Running order was updated!");
      		}
        	if(close) this.$root.close_bottom_sheet()
      	})
      	.receive("error", (msg) => {
      		console.log(msg);
      		if (typeof(self.id) == "undefined") {
      			self.$message.warning("Unable to create running order!");
      		} else {
      			self.$message.warning("Unable to update running order!");
     			}
      		if(close) this.$root.close_bottom_sheet()
      	});
      }
    }
  }
}
</script>
